import { defineMessages } from 'react-intl';
export default defineMessages({
  commoncannotPay: {
    id: 'common.cannotPay',
    defaultMessage: '存在加菜单未处理，不能结账。请联系商户',
  },
  commonisSelected: {
    id: 'common.isSelected',
    defaultMessage: '选好啦',
  },
  commonorderCenter: {
    id: 'common.orderCenter',
    defaultMessage: '订单中心',
  },
  commonok: {
    id: 'common.ok',
    defaultMessage: '确定',
  },
  commonfillToUse1: {
    id: 'common.fillToUse1',
    defaultMessage: '满{currency}<span className="price">{fullValue}</span>可用',
  },
  commonRule: {
    id: 'common.Rule',
    defaultMessage: '使用规则',
  },
  commoninputPW: {
    id: 'common.inputPW',
    defaultMessage: '请输入密码',
  },
  commonforgetPW: {
    id: 'common.forgetPW',
    defaultMessage: '忘记密码？',
  },
  commondiscount: {
    id: 'common.discount',
    defaultMessage: '折',
  },
  commoncoupon: {
    id: 'common.coupon',
    defaultMessage: '礼品券',
  },
  commonwoman: {
    id: 'common.woman',
    defaultMessage: '女士',
  },
  commonman: {
    id: 'common.man',
    defaultMessage: '先生',
  },
  commonreturn: {
    id: 'common.return',
    defaultMessage: '返回',
  },
  commoncheckPN: {
    id: 'common.checkPN',
    defaultMessage: '验证手机号',
  },
  commonLoading: {
    id: 'common.loading',
    defaultMessage: '加载中',
  },
  loadingText: {
    id: 'common.getLoading',
    defaultMessage: '领取中...',
  },
});



// WEBPACK FOOTER //
// ./src/intl/messages/common/index.js